import { FrontendLogg, LoggLevel } from "../api/apiTypes";
import { ApiError } from "../api/api.utils";
import { loggApi } from "../api/logg.api";
import { FieldErrors } from "react-hook-form";
import { AnmeldelseUtkast } from "@politiet/anmeldelse-lib/types/anmeldelseUtkast.typer";
import { ErrorAction, track } from "../api/tracking";
import StackTrace from "stacktrace-js";
import { AxiosError } from "axios";

export const logFrontendToBackend = (
  error: Error,
  level: LoggLevel = LoggLevel.ERROR,
  anmeldelseId?: string,
) => {
  if (error instanceof ApiError && error.status === 429) {
    track.error(
      ErrorAction.RateLimitExceeded,
      `${error.name}: ${error.message}`,
    );
    return; // Ikke logg 429-feil til backend fordi den indikerer at man har kalt opp backend for mye
  }

  let logLevel = level;
  if (error instanceof AxiosError && error.code === "ERR_NETWORK") {
    logLevel = LoggLevel.WARN;
  }

  void extractStacktrace(error).then((stack) => {
    const errorForBackend: FrontendLogg = {
      level: logLevel,
      name: error.name,
      stack: stack,
      message: error.message,
      status: applyStatusIfAny(error),
      userAgent: window.navigator.userAgent,
    };

    return loggApi.opprettLogg(errorForBackend, anmeldelseId);
  });
};

export const logFieldErrorsToBackend = (
  error: FieldErrors<AnmeldelseUtkast>,
  anmeldelseId: string,
) => {
  const errorForBackend: FrontendLogg = {
    level: LoggLevel.ERROR,
    name: "FieldErrors<AnmeldelseUtkast>",
    stack: JSON.stringify(error),
    message: "Feil under submit av skjema",
  };

  void loggApi.opprettLogg(errorForBackend, anmeldelseId);
};

async function extractStacktrace(error: Error): Promise<string> {
  try {
    const stackFrames = await StackTrace.fromError(error);
    return stackFrames.map((stackFrame) => stackFrame.toString()).join("\n");
  } catch {
    return error.stack || "Stack er undefined";
  }
}

const applyStatusIfAny = (error: Error): number | undefined =>
  error instanceof ApiError ? error.status : undefined;
